import type { GetMetricStatusFilterFromSearchParamsParams, MetricStatusFilter } from '../types';

const supportedStatusFilters: MetricStatusFilter[] = ['active', 'deprecated', 'archived', 'all'];
const defaultStatusFilter: MetricStatusFilter = 'active';

const getMetricStatusFilterFromSearchParams = ({
    value,
}: GetMetricStatusFilterFromSearchParamsParams): MetricStatusFilter => {
    if (value && supportedStatusFilters.includes(value as MetricStatusFilter)) {
        return value as MetricStatusFilter;
    }

    return defaultStatusFilter;
};

export default getMetricStatusFilterFromSearchParams;
